import { render, staticRenderFns } from "./view-patient.vue?vue&type=template&id=9ae6846a&scoped=true"
import script from "./view-patient.vue?vue&type=script&lang=js"
export * from "./view-patient.vue?vue&type=script&lang=js"
import style0 from "./view-patient.vue?vue&type=style&index=0&id=9ae6846a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae6846a",
  null
  
)

export default component.exports